<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
<div>
  <router-link
    :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
  >{{news.textParams[1]}}</router-link>
  {{$t('news.template.candidate.valRevoked.p1')}}
  <router-link :to="{name: 'forum', params: {id: news.textParams[2]}}">
    {{news.textParams[3]}}
  </router-link>
  ({{$t('news.template.candidate.valRevoked.p2')}} {{news.textParams[4]}} - {{news.textParams[5]}}).
</div>
</template>
